// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"c7566c98","453":"a6af8bf8"}[chunkId] + ".chunk.js";
};